// src/breakpoints.ts
var breakpoints_default = {
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1440,
  "2xl": 1600
};
var legacyBreakpoints = {
  s: 320,
  m: 768,
  l: 1024,
  xl: 1440
};
export {
  breakpoints_default as default,
  legacyBreakpoints
};
